export const chargeExplain = {
    "connectToBank": "Login to the bank account"
};
